/**
 * Globo Indonesia Translation Fix
 *
 * Daftar mapping label yang perlu di-fix dari Globo translation.
 * Format: 'data-fvalue': 'Label yang benar'
 *
 * Cara pakai:
 *   - Tambahkan entry baru ke LABEL_FIXES di bawah
 *   - Key = nilai data-fvalue dari button Globo
 *   - Value = label yang ingin ditampilkan
 */
(function () {
  var LABEL_FIXES = {
    // ─── Size Filter (Ukuran) ───────────────────────────
    // Globo menganggap 0, 00, 000 sama, jadi semua jadi "00"
    "000": "000",
    "00": "00",
    0: "0",

    // ─── Tambahkan mapping lain di sini ─────────────────
    // Contoh:
    // 'ONE SIZE': 'SATU UKURAN',
    // 'XS': 'XS',
  };

  function fixFilterLabels() {
    var buttons = document.querySelectorAll(
      '.gf-option-box button[role="checkbox"][data-fvalue], .gf-option-box a[data-fvalue]',
    );

    buttons.forEach(function (btn) {
      var fvalue = btn.getAttribute("data-fvalue");
      if (!fvalue || !(fvalue in LABEL_FIXES)) return;

      var correctLabel = LABEL_FIXES[fvalue];
      var label = btn.querySelector(".gf-label");

      if (label && label.textContent.trim() !== correctLabel) {
        label.textContent = correctLabel;
      }

      if (btn.getAttribute("title") !== correctLabel) {
        btn.setAttribute("title", correctLabel);
      }
    });
  }

  // Run on initial load (after Globo has rendered)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(fixFilterLabels, 1500);
    });
  } else {
    setTimeout(fixFilterLabels, 1500);
  }

  // Run every time Globo re-renders filters
  window.addEventListener("globoFilterRenderCompleted", function () {
    setTimeout(fixFilterLabels, 300);
  });
})();

// ─────────────────────────────────────────────────────────────────────────────
(function () {
  // Discount Ninja translation hook is temporarily disabled.
  /*
  var htmlLang = document.documentElement.lang || "";
  if (htmlLang.toLowerCase().indexOf("id") !== 0) return;

  var DN_TRANSLATIONS = {
    "Promo Code": "Kode Promo",
    Apply: "Terapkan",
    Applied: "Diterapkan",
    Remove: "Hapus",

    "Discount code applied successfully": "Kode diskon berhasil diterapkan",
    "Discount code cannot be applied to the cart. Restrictions may apply or the cart may not contain the correct items to use this discount.":
      "Kode diskon tidak dapat diterapkan ke keranjang. Syarat berlaku atau keranjang tidak memenuhi persyaratan.",
    "Discount code cannot be combined with the offers applied to the cart.":
      "Kode diskon tidak dapat digabungkan dengan promo yang sudah diterapkan.",
    "The promo code submitted was not recognized. Please try again.":
      "Kode promo yang dimasukkan tidak dikenali. Silakan coba lagi.",
    "The discount code cannot be applied to the cart. Please ensure the cart meets the requirements to apply this discount code.":
      "Kode diskon tidak dapat diterapkan. Pastikan keranjang memenuhi persyaratan kode diskon ini.",
  };

  var CLASS_TRANSLATIONS = {
    "limoniapps-discountninja-cartdiscountfield-applied-message":
      "Kode diskon berhasil diterapkan",
    "limoniapps-discountninja-cartdiscountfield-notapplied-message":
      "Kode diskon tidak dapat diterapkan ke keranjang. Syarat berlaku atau keranjang tidak memenuhi persyaratan.",
    "limoniapps-discountninja-cartdiscountfield-notcombinable-message":
      "Kode diskon tidak dapat digabungkan dengan promo yang sudah diterapkan.",
    "limoniapps-discountninja-cartdiscountfield-notfound-message":
      "Kode promo yang dimasukkan tidak dikenali. Silakan coba lagi.",
    "limoniapps-discountninja-cartdiscountfield-notapplied-reason":
      "Kode diskon tidak dapat diterapkan. Pastikan keranjang memenuhi persyaratan kode diskon ini.",
  };

  function replaceDeepTextNodes(el, original, translated) {
    var walker = document.createTreeWalker(
      el,
      NodeFilter.SHOW_TEXT,
      null,
      false,
    );
    var node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() === original) {
        node.textContent = node.textContent.replace(original, translated);
      }
    }
  }

  function translateElement(el) {
    if (el.hasAttribute && el.hasAttribute("placeholder")) {
      var ph = el.getAttribute("placeholder").trim();
      if (DN_TRANSLATIONS[ph]) {
        el.setAttribute("placeholder", DN_TRANSLATIONS[ph]);
      }
    }

    var text = el.textContent.trim();
    if (text && DN_TRANSLATIONS[text]) {
      replaceDeepTextNodes(el, text, DN_TRANSLATIONS[text]);
    }
  }

  function translateDiscountNinja() {
    var wrapper = document.querySelector(
      ".limoniapps-discountninja-cartdiscountfield-wrapper",
    );
    if (!wrapper) return;

    var elements = wrapper.querySelectorAll("p, span, button, input");
    elements.forEach(translateElement);

    for (var cls in CLASS_TRANSLATIONS) {
      var feedbackDiv = wrapper.querySelector("." + cls);
      if (!feedbackDiv) continue;
      if (feedbackDiv.style.display === "none") continue;

      var p = feedbackDiv.querySelector("p");
      if (p) {
        p.textContent = CLASS_TRANSLATIONS[cls];
      }
    }
  }

  var _observing = false;
  var DN_WRAPPER = "limoniapps-discountninja-cartdiscountfield-wrapper";
  var DN_PLACEHOLDER =
    ".limoniapps-discountninja-cartdiscountfield-placeholder";

  function startObserver() {
    if (_observing) return;
    _observing = true;

    var _timer = null;

    var observer = new MutationObserver(function (mutations) {
      var freshWrapper = false;

      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];

        if (m.type === "childList" && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (node.nodeType !== 1) continue;
            if (
              node.classList.contains(DN_WRAPPER) ||
              node.querySelector("." + DN_WRAPPER)
            ) {
              freshWrapper = true;
              break;
            }
          }
        }
      }

      clearTimeout(_timer);
      if (freshWrapper) {
        translateDiscountNinja();
      } else {
        _timer = setTimeout(translateDiscountNinja, 150);
      }
    });

    var stableTarget =
      document.querySelector(DN_PLACEHOLDER) ||
      document.querySelector("cart-drawer") ||
      document.querySelector("#CartDrawer") ||
      document.body;

    observer.observe(stableTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  function init() {
    setTimeout(translateDiscountNinja, 800);
    setTimeout(translateDiscountNinja, 2000);
    startObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  */
})();
